<template>
	<div class="one">
		<div class="container">
			<div class="content">
				<ul>
					<li @click="gotoDetail()">
						<img src="https://t1.hddhhn.com/uploads/tu/201812/244/u=1183225980,2330842277&fm=11&gp=0.jpg"/>
						<p>雪亮工程是视频门禁解决方案</p>
					</li>
				</ul>
				
				<div class="pages">
					<el-pagination
					  background
					  layout="prev, pager, next"
					  prev-text='上一页'
					  next-text='下一页'
					  @current-change="handleCurrentChange"
					  :total="10">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'one',
				
			}
		},
		methods:{
			
			handleChange(val) {
	//	        console.log(val);
		      },
		//	      点击的当前页数
		      handleCurrentChange(){
	//	      	console.log(this.currentPage1);//当前显示的页数
		      },
		      gotoDetail(){
		      	this.$router.push({path:'/SoluDetail'})
		      }
		},
		created(){
			
		}
	}
</script>

<style lang="less" scoped="scoped">
.one{
	margin-bottom: 100px;
	.content{
							ul{
								display: flex;
								flex-wrap: wrap;
								justify-content: space-between;
								li{
									display: inline-block;
									width: 32%;
									height: 260px;
									margin-bottom: 25px;
									background: #eee;
									img{
										width: 100%;
										height: 80%;
										padding: 10px;
									}
									p{
										padding: 10px;
										height: 55px;
										width: 100%;
										text-align: center;
										padding-top: 13px;
										color: #146BFF;
										font-size: 18px;
									}
								}
					}
					.pages{
						margin-top: 30px;
						font-size: 20px;
						text-align: right;
					}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Solution/Scom/One.vue